export const richcottons = [
  { image: "/images/richcotton/1.jpg" },
  { image: "/images/richcotton/2.jpg" },
  { image: "/images/richcotton/3.jpg" },
  { image: "/images/richcotton/4.jpg" },
];
